import React from "react";

const RenderAppraiser = ({ appraiser, isCompleted = false }) => {
    let display = "Not specified";
    let warning = false;

    if (!!appraiser?.length && appraiser[0]?.name) {
        display = appraiser[0].name;
    } else {
        if (!isCompleted) {
            warning = true;
        }
    }

    return <span className={warning ? "error" : ""}>{display}</span>;
};

export default RenderAppraiser;
